import React from "react";
import "./CloudManageHero.css";
import mainimage from "../cloudmanageassets/heroimg.png";

export default function CloudManageHero() {
  return (
    <div id="manage-hero" className="outsourcemainclass">
      <div className="left">
        <h1>Unlock the Power of the Cloud with Our Managed Services</h1>
        <p>
          We deliver secure, scalable, and expertly managed cloud solutions that
          empower modern enterprises to optimize performance, ensure compliance,
          reduce complexity, and accelerate innovation across their cloud
          environments.
        </p>
      </div>
      <div className="right">
        <img src={mainimage} alt="error" />
      </div>
    </div>
  );
}
